import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { formatedSelectOption } from 'helper';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function AddBusinessEstablishmentModal({
  transactionId,
  businessList,
  createInput,
  createLineBusiness,
  getBusinessEstablishmentsList2,
  formData,
  setFormData,

  showTransaction,
}) {
  const setModal = useContext(ModalContext);

  const handleOnChangeSelect = (key, label) => e => {
    setFormData({
      ...formData,
      [key]: e.value,
      [label]: e.label,
      business_establishment_address: _.get(e, 'data.attributes.address'),
    });
  };

  const handleOnSubmit = e => {
    e.preventDefault();
    const args = [
      {
        ...formData,
      },
    ];

    createLineBusiness(transactionId, { business_establishments: args }, () => {
      setModal({ isOpen: false });
      showTransaction(transactionId);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getBusinessEstablishmentsList2();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Business Establishment Name
            </label>
            <Select
              value={
                businessList.find(
                  item =>
                    +_.get(formData, 'business_establishment_id') ===
                    +_.get(item, 'value')
                ) || ''
              }
              placeholder="Select Module"
              onChange={handleOnChangeSelect(
                'business_establishment_id',
                'business_establishments'
              )}
              options={businessList}
            />
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'business_establishment_address', label: 'Address:' },
              { required: true, disabled: true }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

AddBusinessEstablishmentModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  getBusinessEstablishmentsList2: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  businessList: PropTypes.instanceOf(Object).isRequired,
  transactionId: PropTypes.string.isRequired,
  createLineBusiness: PropTypes.instanceOf(Function).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  businessList: formatedSelectOption(
    _.get(api, `${c.GET_BUSINESS_ESTABLISMENT_TWO}.list`) || []
  ),
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AddBusinessEstablishmentModal);
